<template>
  <div class="flex">
    <div class="white-bg left-panel flex-column">
      <div class="links flex-column">
        <!-- <div>
          <p class="linksp">
            <span class="iconfont icon-bangzhuzhongxin text-gray-500"></span>
            <span class="font-medium">{{ $t("帮助中心") }}</span>
          </p>
          <router-link v-for="item in helpLink" :key="item.tag" :to="{ name: 'helpCenter', query: { tag: item.tag } }"
            class="link" :class="{'active_link' : current_option == item.tag}"
            @click.native="handleClick(item.tag, item.title)">
            {{ $t(item.title) }}</router-link>
        </div> -->
        <div>
          <p class="linksp">
            <span class="iconfont icon-fuwushengming text-gray-500"></span>
            <span class="font-medium">{{ $t("服务声明") }}</span>
          </p>
          <router-link v-for="item in serveLink" :key="item.tag" :to="{ name: 'serveState', query: { tag: item.tag } }"
            class="link" :class="{'active_link' : current_option == item.tag}"
            @click.native="handleClick(item.tag, item.title)">
            {{ $t(item.title) }}</router-link>
        </div>
        <div>
          <p class="linksp">
            <span class="iconfont icon-guanyuwomen text-gray-500"></span>
            <span class="font-medium">{{ $t("关于我们") }}</span>
          </p>
          <router-link v-for="item in aboutUsLinks" :key="item.tag" :to="{ name: item.name, query: { tag: item.tag } }"
            class="link" :class="{'active_link' : current_option == item.tag}"
            @click.native="handleClick(item.tag, item.title)">{{ $t(item.title) }}</router-link>
        </div>
        <div>
          <p class="linksp cursor-pointer link-title" @click="$goTo('/help/feedback?tag=feedback'), handleClick('feedback', '')"
            :class="{ active: current_option == 'feedback' }">
            <span class="iconfont icon-yijianfankui text-gray-500"></span>
            <span class="font-medium">{{ $t("意见反馈") }}</span>
          </p>
        </div>
        <div>
          <p class="linksp cursor-pointer link-title" @click="$goTo('/help/callus?tag=callus'), handleClick('callus', '')"
            :class="{ active: current_option == 'callus' }">
            <span class="iconfont icon-lianxiwomen text-gray-500"></span>
            <span class="font-medium">{{ $t("联系我们") }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="right-panel flex-1 bg-white p-8">
      <breadcrumb :data="current_title"></breadcrumb>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { ref, watchEffect } from "@vue/composition-api";
import breadcrumb from "@/components/help/breadcrumb.vue";
export default {
  components: { breadcrumb },

  setup(props, ctx) {
    //当前选项
    const helpLink = ref([
      { title: "常见问题", tag: "help" },
      { title: "订单问题", tag: "order_issue" },
      { title: "物流问题", tag: "lgs_issue" },
      { title: "优惠券问题", tag: "cp_issue" },
      { title: "退货与售后问题", tag: "after_sale" },
    ]);
    const serveLink = ref([
      { title: "交易规则", tag: "trade_rule" },
      { title: "用户使用协议", tag: "service" },
      { title: "隐私政策", tag: "privacy" },
      { title: "免责声明", tag: "notice" },
    ]);
    const aboutUsLinks = ref([
      {
        title: "关于花易宝",
        name: "huayibao",
        tag: "huayibao",
      },
      { title: "新闻资讯", name: "news", tag: "news" },
      // {
      //   title: "意见反馈",
      //   name: "feedback",
      //   tag: "feedback",
      // },
      // {
      //   title: "联系我们",
      //   name: "callus",
      //   tag: "callus",
      // },
    ]);
    const current_option = ref();
    const current_title = ref();
    watchEffect(() => {
      if (ctx.root.$route.query.tag ) {
        current_option.value = ctx.root.$route.query.tag;
        if (current_option.value == 'feedback' || current_option.value == 'callus') {
          return
        }
        const arr = helpLink.value
          .concat(serveLink.value)
          .concat(aboutUsLinks.value);
        const res1 = arr.map((item) => item.tag.includes(current_option.value));
        const res2 = res1.indexOf(true);
        current_title.value = arr[res2]?.title;
      }
    });

    const handleClick = (...args) => {
      current_option.value = args[0];
      current_title.value = args[1];
    };

    return {
      helpLink,
      current_option,
      serveLink,
      aboutUsLinks,
      handleClick,
      current_title,
    };
  },
};
</script>
<style scoped lang="scss">
@import "@/style/theme.scss";
.left-panel {
  background: white;
  padding: 2rem 0;
  width: 14rem;
  margin-right: $panel-margin;
  height: 40rem;
  align-items: center;
}
.left-panel .links {
  width: 100%;
  text-align: left;
}
.left-panel .links .linksp > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.left-panel .links .linksp {
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.left-panel .links .link-title:hover {
  color: $main-color;
}
.left-panel .links .link-title.active {
  color: $main-color !important;
}
.left-panel .links .link {
  display: block;
  color: #333333;
  text-decoration: none;
  padding-left: 3.5rem;
  line-height: 2.2rem;
  font-size: 0.88rem;
  white-space: nowrap;
}
.left-panel .links .link:hover {
  color: $main-color;
}
.active_link {
  color: $main-color !important;
}
.right-panel {
  min-height: calc(100vh - 180px);
}
</style>
